import { GetterTree } from 'vuex';
import { NavigationState } from './types';

const getters: GetterTree<NavigationState, any> = {
  receivedAppsCount: (state) => state.receivedAppsCount,
  unreadMessageCount: (state) => state.unreadMessageCount,
  unreadBookingRequestsCount: (state) => state.unreadBookingRequestsCount,
};

export default getters;
